import { Box, Modal } from "@mui/material";
import {
  MainContainerModal,
  MainContainerWrapper,
} from "../../styles/Main.styles";
import CancelIcon from "@mui/icons-material/Cancel";

interface IModalFC {
  open: boolean;
  onClose(): void;
  children: JSX.Element | JSX.Element[];
}

export const ModalFC = ({ onClose, open, children }: IModalFC) => {
  return (
    <Modal open={open}>
      <MainContainerModal>
        <MainContainerWrapper>
          <Box display={"flex"} justifyContent={"flex-end"} mb={2}>
            <CancelIcon
              color="error"
              style={{ cursor: "pointer", fontSize: 30 }}
              onClick={onClose}
            />
          </Box>
          {children}
        </MainContainerWrapper>
      </MainContainerModal>
    </Modal>
  );
};
